import { Skeleton } from 'antd';

const Loading: React.FC = () => (
  <></>
);

export default Loading;
